import { createStyleAttributeHandlers, StyleAttributes } from "./attributes/styleAttributes";

const stylesToCopy = {
	"border": "border",
	"padding": "padding",
	"paddingLeft": "padding-left",
	"paddingRight": "padding-right",
	"paddingTop": "padding-top",
	"paddingBottom": "padding-bottom",
	"width": "width",
	"height": "height",
	"background": "background",
	"backgroundColor": "background-color",
	"backgroundImage": "background-image",
	"display": "display"
};

type TableCellStyleKeysToCopy = keyof typeof stylesToCopy;
export type TableCellStyleAttributes = StyleAttributes<TableCellStyleKeysToCopy>;

const {
	getStyleAttributes,
	setStyleAttributes,
	styleAttributeDefinitions
} = createStyleAttributeHandlers(stylesToCopy);

export {
	getStyleAttributes as getTableCellStyleAttributes,
	setStyleAttributes as setTableCellStyleAttributes,
	styleAttributeDefinitions as tableCellStyleAttributeDefinitions
};